import { ApiError } from '@portal/api/utils/ApiError';
import { environment } from '@portal/constants/environment';
import { StoreCode } from '@portal/schema/storeCode';
import { ZodError } from 'zod';
import { shopifyAdminApiDevSchema, shopifyAdminApiProductionSchema } from './schemas';

const { SHOPIFY_ADMIN_API_AUTH } = process.env;

const SHOPIFY_ADMIN_API_AUTH_KEYS: Readonly<Record<StoreCode, string>> = JSON.parse(
  SHOPIFY_ADMIN_API_AUTH ?? '{}'
);
const schema =
  environment === 'local' || environment === 'development'
    ? shopifyAdminApiDevSchema
    : shopifyAdminApiProductionSchema;

export function getShopifyAdminApiHeaders(store: StoreCode) {
  try {
    const key = SHOPIFY_ADMIN_API_AUTH_KEYS[store];
    if (!key) {
      // Zod will throw if this fails. Seems like we allow empty values for
      // certain keys in dev, so this should support nullability between
      // dev/prod while only caring about the provided key.
      schema.parse(SHOPIFY_ADMIN_API_AUTH_KEYS);
    }
    return {
      Authorization: key
    };
  } catch (error) {
    if (error instanceof ZodError) {
      throw new ApiError(500, 'Unable to find shopify admin api keys', {
        message: 'Unable to find shopify admin api keys',
        detail: error.errors
      });
    } else {
      throw error;
    }
  }
}

export const RECAPTCHA_GOOGLE_CLOUD_PROJECT =
  process.env.RECAPTCHA_GOOGLE_CLOUD_PROJECT || 'site-checkout-331002';
export const RECAPTCHA_GOOGLE_CLOUD_API_KEY =
  process.env.RECAPTCHA_GOOGLE_CLOUD_API_KEY || 'AIzaSyAsZAl70ICM6VGJ3cJ4_Edja2LyQd_H_lc';
